import { gql } from '@apollo/client';

export const ALL_USER_INSIGHTS_PAGED = gql`
  query AllUserInsightsPaged($input: getInsightsInput!) {
    insights: allUserInsightsPaged(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          tags {
            id
            name
          }
          url
          image
          isFavorite
          width
          height
        }
      }
    }
  }
`;
